import { render, staticRenderFns } from "./date-format.vue?vue&type=template&id=082aa188&"
import script from "./date-format.vue?vue&type=script&lang=js&"
export * from "./date-format.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports